import { render, staticRenderFns } from "./ProfileGameForm.vue?vue&type=template&id=29fc4f0e&scoped=true&"
import script from "./ProfileGameForm.vue?vue&type=script&lang=js&"
export * from "./ProfileGameForm.vue?vue&type=script&lang=js&"
import style0 from "./ProfileGameForm.vue?vue&type=style&index=0&id=29fc4f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fc4f0e",
  null
  
)

export default component.exports